
let host = '';
let url = '';

if (process.env.REACT_PUBLIC_ENVIROMENT === 'localhost') {
    host = 'http://localhost:8080';
    url = 'http://localhost:3000';
}
else if(process.env.REACT_APP__PUBLIC_ENVIROMENT === 'SIT1') {
    host = 'https://sit1-apiclient-themoodspaceconnect.innov.co.in';
    url = 'https://sit1-uiclient-themoodspaceconnect.innov.co.in';
}
else if(process.env.REACT_APP__PUBLIC_ENVIROMENT === 'UAT1') {
    host = 'https://uat1-apiclient-themoodspaceconnect.innov.co.in';
    url = 'https://uat1-uiclient-themoodspaceconnect.innov.co.in';
}
else if(process.env.REACT_APP__PUBLIC_ENVIROMENT === 'production') {
    host = 'https://clientapi.themoodspace.com';
    url = 'https://client.themoodspace.com';
}

export const domain = host;
export const websiteUrl = url;
export const basicAuth = process.env.REACT_APP__PUBLIC_BASICAUTH;
export const storageTokenKeyName = 'accessToken';
export const temporaryStorageTokenKeyName = 'temporaryToken';
